export const API_PORTAL_URL = "https://dev.wonyasoft.com/";
export const WONYASOFT_SITE_URL = "https://wonyaso.com/";
export const WONYAPAY_APP_DOWNLOAD_PATH = "/appmobile";
export const WONYAPAY_IOS_STORE_URL =
  "https://apps.apple.com/cd/app/wonyapay/id6740532331?l=fr-FR";
export const WONYAPAY_ANDROID_PACKAGE_ID = "com.wonyasoft.wpay";
export const WONYAPAY_ANDROID_MARKET_URL = `market://details?id=${WONYAPAY_ANDROID_PACKAGE_ID}`;
export const WONYAPAY_ANDROID_STORE_URL = `https://play.google.com/store/apps/details?id=${WONYAPAY_ANDROID_PACKAGE_ID}`;

export const getWonyapaySmartDownloadUrl = (
  browserNavigator = typeof navigator === "undefined" ? undefined : navigator,
) => {
  const userAgent = browserNavigator?.userAgent ?? "";
  const platform = browserNavigator?.platform ?? "";
  const maxTouchPoints = browserNavigator?.maxTouchPoints ?? 0;

  if (/android/i.test(userAgent)) {
    return WONYAPAY_ANDROID_STORE_URL;
  }

  const isAppleMobile =
    /iPhone|iPad|iPod/i.test(userAgent) ||
    (/Mac/i.test(platform) && maxTouchPoints > 1);

  if (isAppleMobile) {
    return WONYAPAY_IOS_STORE_URL;
  }

  return WONYAPAY_APP_DOWNLOAD_PATH;
};
